'use client';

import { ReactNode, useState } from 'react';
import { Maybe } from 'graphql/jsutils/Maybe';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AccordionProps,
} from '@mui/material';
import { Icon, Icons } from '@/common/components/Icon/Icon';
import ReceiptTitleSection from '../ReceiptTitleSection/ReceiptTitleSection';

import {
  acconrdionWrapperStyles,
  accordionSummaryStyles,
  styledAccordionDetails,
} from './ReceiptAccordion.styled.';
import { PrimaryColors } from '@/common/theme/constants';

type ReceiptAccordionProps = {
  title: string;
  price?: string;
  currency?: Maybe<string>;
  children: ReactNode;
  oldPrice?: string | number;
  expanded?: boolean;
  loading?: boolean;
} & AccordionProps;

export default function ReceiptAccordion({
  title,
  price,
  currency,
  oldPrice,
  children,
  expanded,
  loading,
  ...props
}: ReceiptAccordionProps) {
  const [isExpanded, setIsExpanded] = useState(expanded);

  return (
    <Accordion
      disableGutters
      elevation={0}
      onChange={(_, newExpanded) => setIsExpanded(newExpanded)}
      expanded={isExpanded}
      sx={acconrdionWrapperStyles}
      {...props}
    >
      <AccordionSummary
        sx={accordionSummaryStyles}
        expandIcon={
          <Icon color={PrimaryColors.black} icon={Icons.ChevronDown} />
        }
      >
        <ReceiptTitleSection
          title={title}
          price={price}
          currency={currency}
          oldPrice={oldPrice}
          loading={loading}
        />
      </AccordionSummary>
      <AccordionDetails sx={styledAccordionDetails}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
